import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { commonAppConfig } from '@ui/layout/common-app/common-app.config';
import { AppRoutingModule } from './app-routing.module';
import { GOOGLE_MAPS_API_KEY } from '@core/maps/maps.constants';
import { ThirdLevelMenuFactory } from '@core/menu/third-level-menu.service';
import { thirdLevelMenu } from './sub.menu';
import { MonitoringErrorFilterState } from '@core/monitoring/monitoring-error-filter.state';
import { AgmCoreModule } from 'ng-agm-core-lib';
import { MonitoringState } from '@core/monitoring/monitoring.state';
import { MonitoringSchemeState } from './shared/state/monitoring-scheme.state';


export const loadSubMenu: (thirdLevelMenuFactory: ThirdLevelMenuFactory) => () => Promise<boolean> =
    (thirdLevelMenuFactory: ThirdLevelMenuFactory) => () =>
        thirdLevelMenuFactory.loadMenu(thirdLevelMenu);

export const appConfig: ApplicationConfig = mergeApplicationConfig(commonAppConfig, {
    providers: [
        importProvidersFrom(
            AppRoutingModule,
            AgmCoreModule.forRoot({
                apiKey: GOOGLE_MAPS_API_KEY,
            }),
        ),
        {
            provide: APP_INITIALIZER,
            useFactory: loadSubMenu,
            deps: [ThirdLevelMenuFactory],
            multi: true,
        },
        MonitoringErrorFilterState,
        MonitoringState,
        MonitoringSchemeState,
    ],
});
